export enum ELeaveDaysStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  COMPLETED = 'completed',
}

export enum ELeaveDaysType {
  CARRY_OVER_LEAVE = 'carry_over',
  BUSINESS_TRAVEL_LEAVE = 'business_travel_leave',
  VACATION_LEAVE = 'vacation_leave',
  SICK_LEAVE = 'sick_leave',
}
